// ── reviewMarkup ──────────────────────────────────────────────────────────────
// Markdown-LITE for reviews — a tiny, safe subset with no toolbar and no raw HTML:
//   **bold**   *italic*   ||spoiler||   (newlines are preserved by the renderer).
// Pure tokenizer, unit-tested; the React renderer lives in components/ReviewBody.jsx.

// Order matters: bold (**) is tried before italic (*) so **x** isn't mis-split. Each
// marker's inner text stops at its own delimiter and never crosses a newline. The
// @mention alternative uses a lookbehind so an email ("foo@bar") is never linkified —
// only an @ that starts a word counts.
const TOKEN = /(\*\*[^*\n]+\*\*|\*[^*\n]+\*|\|\|[^|\n]+\|\||(?<![A-Za-z0-9_])@[A-Za-z0-9_]{2,30})/g

// Username charset for a mention (matches the handles the composer autocompletes).
const MENTION_RE = /(?<![A-Za-z0-9_])@([A-Za-z0-9_]{2,30})/g

// Split a string into typed segments: { t: 'text'|'b'|'i'|'s'|'m', v }. 'm' is a
// @mention (v is the bare username). Unmatched text (including a lone/unclosed marker)
// passes through as plain 'text'.
export function parseInline(text) {
  const parts = []
  let last = 0, m
  TOKEN.lastIndex = 0
  while ((m = TOKEN.exec(text)) !== null) {
    if (m.index > last) parts.push({ t: 'text', v: text.slice(last, m.index) })
    const tok = m[0]
    if (tok.startsWith('**'))      parts.push({ t: 'b', v: tok.slice(2, -2) })
    else if (tok.startsWith('||')) parts.push({ t: 's', v: tok.slice(2, -2) })
    else if (tok[0] === '@')       parts.push({ t: 'm', v: tok.slice(1) })
    else                           parts.push({ t: 'i', v: tok.slice(1, -1) })
    last = m.index + tok.length
  }
  if (last < text.length) parts.push({ t: 'text', v: text.slice(last) })
  return parts
}

// Extract the unique set of mentioned usernames (lowercased) from a body — used to
// resolve who to notify when a public review is saved.
export function extractMentions(text) {
  const out = new Set()
  let m
  MENTION_RE.lastIndex = 0
  while ((m = MENTION_RE.exec(String(text || ''))) !== null) out.add(m[1].toLowerCase())
  return [...out]
}
